import { Component, OnInit, ViewChild,Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import {MatTableDataSource, MatPaginator,MatSnackBar,MatDialogConfig } from '@angular/material';
import { OrganisationService } from 'src/app/shared/services/organisation.service';
import { AppSettings } from '../../../app.constant';
import { User } from '../../../shared/interface/user';
import { DataSource } from '@angular/cdk/table';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogboxComponent} from '../../../public/dialogbox/dialogbox.component';

@Component({
  selector: 'app-organisation-table',
  templateUrl: './organisation-table.component.html',
  styleUrls: ['./organisation-table.component.css']
})
export class OrganisationTableComponent implements OnInit {
  displayedColumns: string[] =  ['Code','OrganisationName','Edit'];
  httpResponseMessage:any;
  public progressBar:boolean = true;
  post:any;
  posts:any;
  status:any;
  public resultdata:any;
  dataSource;
  organisation:any;
  errorMessage: String;
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;

  @Output() messageEvent = new EventEmitter<string>();

  constructor(
    private _organisationservice:OrganisationService, 
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
   
  ngOnInit() {
    this._organisationservice.refreshNeeded$
    .subscribe(()=>{
      this.getAllOrganisation();
    })
    this.getAllOrganisation();
  }

  getAllOrganisation() {
      this._organisationservice.getAllOrganisation(AppSettings.API_ENDPOINT+AppSettings.GetAllOrganisation)
      .subscribe(result =>{
        this.resultdata=result;
        this.progressBar = false;
        if(!result){
         return; }
      this.dataSource = new MatTableDataSource(this.resultdata);
      this.dataSource.paginator = this.paginator;
      });
  }

  applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onEditOrganisation(param:any):void{
       var o={PK_OrganisationID:param.PK_OrganisationID}
       this.post=JSON.stringify(o);
       this._organisationservice.getOrganisationByID(AppSettings.API_ENDPOINT+AppSettings.GetOrganisationByID,this.post).subscribe(
         data => {
             this.organisation=data;
             this.messageEvent.emit(this.organisation);
           },
        error => this.errorMessage = <any>error)
  }

  onDeleteOrganisation(param:any):void{
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
              title:"Organisation",
              data: param.OrganisationName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent,dialogConfig,);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
    this.status=result;
    if(this.status=="ok"){
      var o={PK_OrganisationID:param.PK_OrganisationID}
      this.post=JSON.stringify(o);
      this._organisationservice.deleteOrganisationByID(AppSettings.API_ENDPOINT+AppSettings.DeleteOrganisation,this.post).subscribe(
          data =>{
              this.httpResponseMessage=data
              this.openSnackBar(this.httpResponseMessage,'');
          },
              error => this.errorMessage = <any>error)
    }
   });
  }
  
  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message,action ,{
      duration: 2000,
      verticalPosition: 'bottom'
    });
    }
}
